import { render, staticRenderFns } from "./AddPricelistDetails.vue?vue&type=template&id=213dd37a&scoped=true&"
import script from "./AddPricelistDetails.vue?vue&type=script&lang=js&"
export * from "./AddPricelistDetails.vue?vue&type=script&lang=js&"
import style0 from "./AddPricelistDetails.vue?vue&type=style&index=0&id=213dd37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213dd37a",
  null
  
)

export default component.exports